import classNames from 'classnames';
import React from 'react';

import { Icon } from './Icon';

export interface PanelProps {
  variant: 'danger' | 'success' | 'warning';
  children?: React.ReactNode;
  onHide?: () => void;
  hidden?: boolean;
  className?: string;
}

export const Panel: React.FC<PanelProps> = ({
  children,
  variant,
  onHide,
  hidden = false,
  className,
}) => {
  if (hidden) {
    return null;
  }
  return (
    <div className={classNames('oejr-panel', variant && `oejr-panel-${variant}`, className)}>
      <div className="oejr-panel-body">{children}</div>
      <div className="oejr-panel-controls">
        <Icon name="times" onClick={onHide} />
      </div>
    </div>
  );
};
